import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilLine = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2667 3C11.3646 2.833 11.4994 2.69066 11.6609 2.58391C11.8224 2.47716 12.0062 2.40885 12.1982 2.38422C12.3902 2.35959 12.5853 2.37929 12.7686 2.44182C12.9518 2.50435 13.1182 2.60804 13.2551 2.74492C13.392 2.8818 13.4957 3.04824 13.5582 3.23145C13.6207 3.41465 13.6404 3.60975 13.6158 3.80176C13.5912 3.99377 13.5228 4.17758 13.4161 4.33907C13.3093 4.50056 13.167 4.63543 13 4.73333L5.06667 12.6667L2.66667 13.3333L3.33333 10.9333L11.2667 3Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPencilLine;
